export const dramas = [
  {
    id: "tangerines",
    title: "苦尽柑来遇见你",
    originalTitle: "폭싹 속았수다",
    year: 2025,
    genres: ["家庭", "爱情", "年代"],
    rating: 9.4,
    heat: 9850,
    episodes: 16,
    status: "更新中",
    platform: "Netflix",
    cast: "IU、朴宝剑、文素利",
    summary: "以济州岛柑橘园为背景，横跨数十年的家庭史诗。倔强的爱纯与沉默的宽植在动荡年代互相扶持，把苦涩的人生一点点熬成回甘的橘子酱。",
    poster: "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20Korean%20drama%20poster%20of%20a%20seaside%20tangerine%20village%20in%20the%201960s%2C%20orange%20grove%20trees%2C%20soft%20golden%20afternoon%20sunlight%2C%20retro%20film%20grain%2C%20emotional%20cinematic%20mood%2C%20muted%20warm%20portrait%20tones&width=440&height=620&seq=kd-poster-01&orientation=portrait"
  },
  {
    id: "queen-of-tears",
    title: "眼泪女王",
    originalTitle: "눈물의 여왕",
    year: 2024,
    genres: ["爱情", "职场", "悬疑"],
    rating: 8.7,
    heat: 9600,
    episodes: 16,
    status: "已完结",
    platform: "tvN",
    cast: "金秀贤、金智媛",
    summary: "百货女王洪海仁与乡村出身的天才律师白贤祐，在婚姻濒临破裂时被一场突如其来的病症重新拉回彼此身边，展开一段又痛又甜的复合之旅。",
    poster: "https://readdy.ai/api/search-image?query=Elegant%20Korean%20drama%20poster%20of%20a%20wealthy%20couple%20standing%20in%20a%20marble%20mansion%20hall%2C%20warm%20chandelier%20light%2C%20rose%20and%20gold%20tones%2C%20luxurious%20romantic%20mood%2C%20cinematic%20portrait%20composition%2C%20soft%20shadow&width=440&height=620&seq=kd-poster-02&orientation=portrait"
  },
  {
    id: "squid-game-3",
    title: "鱿鱼游戏 第三季",
    originalTitle: "오징어 게임 3",
    year: 2025,
    genres: ["惊悚", "悬疑"],
    rating: 8.1,
    heat: 9420,
    episodes: 6,
    status: "已完结",
    platform: "Netflix",
    cast: "李政宰、李秉宪",
    summary: "成奇勋带着复仇的执念重回游戏，却发现规则早已被幕后操盘手改写。这一季把残酷的人性赌局推向终局，每一次选择都直指人心。",
    poster: "https://readdy.ai/api/search-image?query=Dark%20tense%20Korean%20survival%20drama%20poster%20of%20mysterious%20pink%20guard%20masks%20arranged%20in%20a%20shadowy%20arena%2C%20dramatic%20spotlight%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20thriller%20atmosphere%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-03&orientation=portrait"
  },
  {
    id: "the-glory",
    title: "黑暗荣耀",
    originalTitle: "더 글로리",
    year: 2022,
    genres: ["复仇", "悬疑"],
    rating: 9.1,
    heat: 8760,
    episodes: 16,
    status: "已完结",
    platform: "Netflix",
    cast: "宋慧乔、李到晛",
    summary: "被校园暴力摧毁人生的文东恩用十八年布局一场冷静到极致的复仇。她不喊痛，只是把所有加害者一步步请进自己写好的结局里。",
    poster: "https://readdy.ai/api/search-image?query=Moody%20Korean%20revenge%20drama%20poster%20of%20a%20woman%20in%20a%20dark%20winter%20school%20corridor%2C%20cold%20dim%20lighting%2C%20burnished%20amber%20highlights%2C%20ominous%20cinematic%20mood%2C%20portrait%20composition%2C%20film%20grain&width=440&height=620&seq=kd-poster-04&orientation=portrait"
  },
  {
    id: "reply-1988",
    title: "请回答1988",
    originalTitle: "응답하라 1988",
    year: 2015,
    genres: ["家庭", "青春", "年代"],
    rating: 9.7,
    heat: 8100,
    episodes: 20,
    status: "已完结",
    platform: "tvN",
    cast: "李惠利、朴宝剑、柳俊烈",
    summary: "首尔双门洞五户人家的日常，藏着一代人关于邻里、初恋与成长的共同记忆。没有狗血反转，只有把平凡日子拍得滚烫的温柔。",
    poster: "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20Korean%20drama%20poster%20of%20a%201980s%20neighborhood%20alley%20at%20dusk%2C%20old%20brick%20houses%2C%20amber%20streetlamp%20glow%2C%20cozy%20homespun%20mood%2C%20soft%20sepia%20tones%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-05&orientation=portrait"
  },
  {
    id: "crash-landing",
    title: "爱的迫降",
    originalTitle: "사랑의 불시착",
    year: 2019,
    genres: ["爱情", "奇幻"],
    rating: 8.8,
    heat: 8420,
    episodes: 16,
    status: "已完结",
    platform: "tvN",
    cast: "玄彬、孙艺珍",
    summary: "滑翔伞事故让财阀千金尹世莉意外降落在北境，与温柔严谨的军官李正赫相遇。跨越警戒线的爱情，在守护与分离之间慢慢扎根。",
    poster: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20poster%20of%20a%20vast%20green%20alpine%20meadow%20under%20a%20soft%20twilight%20sky%2C%20distant%20mountains%2C%20tender%20wistful%20mood%2C%20muted%20sage%20and%20cream%20tones%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-06&orientation=portrait"
  },
  {
    id: "goblin",
    title: "孤单又灿烂的神：鬼怪",
    originalTitle: "도깨비",
    year: 2016,
    genres: ["奇幻", "爱情"],
    rating: 8.6,
    heat: 8050,
    episodes: 16,
    status: "已完结",
    platform: "tvN",
    cast: "孔刘、金高银、李栋旭",
    summary: "活了九百多年的鬼怪金信，唯有一个能拔出他胸口之剑的“新娘”才能让他结束永生。命运般的相遇，却也是注定告别的开始。",
    poster: "https://readdy.ai/api/search-image?query=Mystical%20Korean%20fantasy%20drama%20poster%20of%20a%20snow%20covered%20cobblestone%20street%20lit%20by%20candle%20flames%2C%20falling%20snow%2C%20eerie%20romantic%20glow%2C%20deep%20teal%20and%20amber%20tones%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-07&orientation=portrait"
  },
  {
    id: "hospital-playlist",
    title: "机智的医生生活",
    originalTitle: "슬기로운 의사생활",
    year: 2020,
    genres: ["医疗", "治愈", "职场"],
    rating: 9.3,
    heat: 7820,
    episodes: 12,
    status: "已完结",
    platform: "tvN",
    cast: "曹政奭、柳演锡、郑敬淏",
    summary: "五位医学院同窗在忙碌的医院里救人也救己，下班后组乐队、吃炸鸡、互相吐槽。专业与温暖并存，是疲惫生活里的一剂良药。",
    poster: "https://readdy.ai/api/search-image?query=Heartwarming%20Korean%20medical%20drama%20poster%20of%20a%20bright%20hospital%20ward%20with%20warm%20afternoon%20light%2C%20friendly%20group%20atmosphere%2C%20clean%20cream%20and%20teal%20tones%2C%20uplifting%20mood%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-08&orientation=portrait"
  },
  {
    id: "my-liberation-notes",
    title: "我的解放日志",
    originalTitle: "나의 해방일지",
    year: 2022,
    genres: ["治愈", "爱情"],
    rating: 8.6,
    heat: 6900,
    episodes: 16,
    status: "已完结",
    platform: "JTBC",
    cast: "李民基、金智媛、孙锡久",
    summary: "住在京畿道郊区的三兄妹日复一日通勤到首尔，被生活磨得沉默寡言。直到一个来路不明的男人住进村子，他们才决定为自己“解放”一次。",
    poster: "https://readdy.ai/api/search-image?query=Quiet%20introspective%20Korean%20drama%20poster%20of%20a%20calm%20suburban%20rice%20field%20at%20sunset%2C%20solitary%20figure%20walking%2C%20soft%20pastel%20sky%2C%20melancholic%20serene%20mood%2C%20muted%20olive%20tones%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-09&orientation=portrait"
  },
  {
    id: "when-the-phone-rings",
    title: "现在拨打的电话",
    originalTitle: "지금 거신 전화는",
    year: 2024,
    genres: ["悬疑", "爱情"],
    rating: 8.4,
    heat: 8340,
    episodes: 12,
    status: "已完结",
    platform: "MBC",
    cast: "柳演锡、蔡秀彬",
    summary: "一对政治联姻的夫妻在沉默中渐行渐远，一通来自“绑匪”的威胁电话，却意外撕开两人假面之下从未说出口的心意。",
    poster: "https://readdy.ai/api/search-image?query=Tense%20romantic%20Korean%20drama%20poster%20of%20an%20elegant%20dark%20political%20mansion%20interior%20at%20night%2C%20vintage%20telephone%20on%20a%20desk%2C%20warm%20amber%20lamp%2C%20mysterious%20mood%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-10&orientation=portrait"
  },
  {
    id: "lovely-runner",
    title: "背着善宰跑",
    originalTitle: "선재 업고 튀어",
    year: 2024,
    genres: ["青春", "奇幻", "爱情"],
    rating: 8.5,
    heat: 8600,
    episodes: 16,
    status: "已完结",
    platform: "tvN",
    cast: "边佑锡、金惠奫",
    summary: "粉丝小率为了拯救偶像善宰，一次次穿越回过去改变命运。在雨夜与校服之间奔跑的不只是时间，还有一整个青春的暗恋。",
    poster: "https://readdy.ai/api/search-image?query=Youthful%20Korean%20drama%20poster%20of%20a%20young%20couple%20sharing%20an%20umbrella%20at%20a%20rainy%20night%20bus%20stop%2C%20warm%20streetlight%20reflections%2C%20tender%20bittersweet%20mood%2C%20amber%20and%20rose%20tones%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-11&orientation=portrait"
  },
  {
    id: "marry-my-husband",
    title: "请和我的老公结婚",
    originalTitle: "내 남편과 결혼해줘",
    year: 2024,
    genres: ["复仇", "爱情", "职场"],
    rating: 7.9,
    heat: 8200,
    episodes: 16,
    status: "已完结",
    platform: "tvN",
    cast: "朴敏英、罗人友",
    summary: "被好友与丈夫联手背叛的姜智媛重回十年前，决定亲手改写人生剧本。这次她不再忍让，而是一步步把命运的主导权抢回自己手里。",
    poster: "https://readdy.ai/api/search-image?query=Stylish%20Korean%20revenge%20drama%20poster%20of%20a%20confident%20woman%20in%20a%20modern%20office%20at%20dusk%2C%20city%20skyline%20behind%20glass%2C%20crisp%20amber%20and%20slate%20tones%2C%20dramatic%20mood%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-12&orientation=portrait"
  },
  {
    id: "business-proposal",
    title: "社内相亲",
    originalTitle: "사내맞선",
    year: 2022,
    genres: ["爱情", "职场"],
    rating: 8.0,
    heat: 7600,
    episodes: 12,
    status: "已完结",
    platform: "SBS",
    cast: "安孝燮、金世正",
    summary: "替闺蜜赴相亲局的申夏莉，撞上的豪门对象竟是自家公司社长。一场想瞒天过海的伪装恋爱，就这样被推着走成了真。",
    poster: "https://readdy.ai/api/search-image?query=Bright%20cheerful%20Korean%20romantic%20comedy%20poster%20of%20a%20sunny%20modern%20office%20with%20playful%20warm%20colors%2C%20clean%20minimal%20desk%20props%2C%20coral%20and%20cream%20tones%2C%20uplifting%20mood%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-13&orientation=portrait"
  },
  {
    id: "signal",
    title: "信号",
    originalTitle: "시그널",
    year: 2016,
    genres: ["悬疑", "惊悚"],
    rating: 9.2,
    heat: 7200,
    episodes: 16,
    status: "已完结",
    platform: "tvN",
    cast: "李帝勋、金惠秀、赵震雄",
    summary: "一台没有电池的老式对讲机，让现代的侧写师与过去的刑警跨越时空联手破案。每通无线电都可能改写历史，也可能带来无法挽回的代价。",
    poster: "https://readdy.ai/api/search-image?query=Gritty%20Korean%20crime%20thriller%20poster%20of%20an%20old%20vintage%20walkie%20talkie%20on%20a%20stained%20desk%2C%20dim%20interrogation%20room%2C%20cold%20amber%20spotlight%2C%20suspenseful%20noir%20mood%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-14&orientation=portrait"
  },
  {
    id: "stranger",
    title: "秘密森林",
    originalTitle: "비밀의 숲",
    year: 2017,
    genres: ["悬疑", "职场"],
    rating: 9.3,
    heat: 7400,
    episodes: 16,
    status: "已完结",
    platform: "tvN",
    cast: "曹承佑、裴斗娜",
    summary: "因手术失去情感的检察官黄始木，与热血刑警韩汝珍联手追查一桩命案背后的权力网络。冷静到极致的推理，撕开体制深处的腐坏。",
    poster: "https://readdy.ai/api/search-image?query=Cool%20restrained%20Korean%20legal%20thriller%20poster%20of%20a%20prosecutor%20office%20stacked%20with%20documents%2C%20harsh%20window%20light%2C%20slate%20and%20amber%20tones%2C%20serious%20cinematic%20mood%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-15&orientation=portrait"
  },
  {
    id: "twenty-five",
    title: "二十五，二十一",
    originalTitle: "스물다섯 스물하나",
    year: 2022,
    genres: ["青春", "爱情", "年代"],
    rating: 8.4,
    heat: 7300,
    episodes: 16,
    status: "已完结",
    platform: "tvN",
    cast: "金泰梨、南柱赫",
    summary: "IMF 风暴席卷的 1998 年，击剑少女罗希度与落魄记者白易辰相遇。他们在并不友好的时代里，把彼此当作重新出发的勇气。",
    poster: "https://readdy.ai/api/search-image?query=Nostalgic%20coming%20of%20age%20Korean%20drama%20poster%20of%20teenagers%20in%201990s%20school%20uniforms%20in%20sunlit%20schoolyard%2C%20warm%20golden%20afternoon%2C%20hopeful%20bittersweet%20mood%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-16&orientation=portrait"
  },
  {
    id: "kingdom",
    title: "王国",
    originalTitle: "킹덤",
    year: 2020,
    genres: ["古装", "惊悚"],
    rating: 8.4,
    heat: 7700,
    episodes: 6,
    status: "已完结",
    platform: "Netflix",
    cast: "朱智勋、裴斗娜",
    summary: "朝鲜王朝末年，一场由权谋与瘟疫引发的丧尸之乱席卷全国。被排挤的王世子一路追查真相，也一路直面人性的崩塌与重生。",
    poster: "https://readdy.ai/api/search-image?query=Epic%20historical%20Korean%20drama%20poster%20of%20a%20Joseon%20dynasty%20palace%20at%20misty%20dawn%2C%20ancient%20tiled%20roofs%2C%20moonlit%20courtyard%2C%20dramatic%20moody%20atmosphere%2C%20deep%20ink%20and%20gold%20tones%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-17&orientation=portrait"
  },
  {
    id: "descendants-sun",
    title: "太阳的后裔",
    originalTitle: "태양의 후예",
    year: 2016,
    genres: ["爱情", "职场"],
    rating: 8.1,
    heat: 7100,
    episodes: 16,
    status: "已完结",
    platform: "KBS",
    cast: "宋仲基、宋慧乔",
    summary: "维和部队大尉与外科医生在战区一次次擦肩，一边是救人的手术台，一边是保命的枪火线。成年人的爱情，谈的是势均力敌的并肩。",
    poster: "https://readdy.ai/api/search-image?query=Dramatic%20Korean%20romance%20drama%20poster%20of%20a%20desert%20military%20outpost%20at%20sunset%2C%20warm%20orange%20sky%2C%20dusty%20terrain%2C%20heroic%20tender%20mood%2C%20amber%20and%20khaki%20tones%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-18&orientation=portrait"
  },
  {
    id: "penthouse",
    title: "顶楼",
    originalTitle: "펜트하우스",
    year: 2020,
    genres: ["悬疑", "复仇", "职场"],
    rating: 7.4,
    heat: 7900,
    episodes: 21,
    status: "已完结",
    platform: "SBS",
    cast: "李智雅、金素妍、俞真",
    summary: "赫拉宫殿里住着一群不择手段往上爬的精英，一桩少女坠楼案把所有华丽假面一层层剥开，欲望与罪恶在顶层豪宅里轮番上演。",
    poster: "https://readdy.ai/api/search-image?query=Overdramatic%20Korean%20thriller%20poster%20of%20a%20luxury%20high%20rise%20apartment%20tower%20at%20night%2C%20glowing%20windows%2C%20fog%20and%20cold%20violet%20free%20lighting%2C%20opulent%20tense%20mood%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-19&orientation=portrait"
  },
  {
    id: "prison-playbook",
    title: "机智的监狱生活",
    originalTitle: "슬기로운 감빵생활",
    year: 2017,
    genres: ["治愈", "职场"],
    rating: 9.1,
    heat: 6800,
    episodes: 16,
    status: "已完结",
    platform: "tvN",
    cast: "朴海秀、郑敬淏",
    summary: "一夜之间从明星球员变成囚犯的金济赫，在监狱这个微缩社会里重新认识人性。残酷环境中的一点点善意，被拍得既好笑又动人。",
    poster: "https://readdy.ai/api/search-image?query=Warm%20quirky%20Korean%20drama%20poster%20of%20a%20prison%20courtyard%20with%20afternoon%20sunlight%2C%20clothesline%20and%20old%20walls%2C%20hopeful%20gentle%20mood%2C%20muted%20ochre%20and%20cream%20tones%2C%20portrait%20composition&width=440&height=620&seq=kd-poster-20&orientation=portrait"
  }
];

export const dramaGenres = [
  "全部",
  "爱情",
  "悬疑",
  "复仇",
  "家庭",
  "青春",
  "奇幻",
  "医疗",
  "古装",
  "惊悚",
  "治愈",
  "职场",
  "年代"
];